import { previewFile } from 'api';

/**
 * @function addImgPath
 * @async
 * @param {User} user
 * @returns {Promise<User>} user
 */
async function addImgPath(user) {
	if (user.vFileId !== '') {
		const imgPath = await previewFile(user.vFileId);
		user.image = imgPath;
	}
	return user;
}

export default addImgPath;
